import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                继母与继姐·人物图鉴
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-200/80">
              聚焦「继母与继姐」漫画的人物设定与关系梳理，为读者整理主角、继母角色、继姐角色的背景故事、
              性格特点与关系演变，帮助新老读者快速理清人物关系网。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-widest text-background-50">站点导航</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link className="transition-colors hover:text-accent-300" to="/">首页</Link></li>
              <li><Link className="transition-colors hover:text-accent-300" to="/characters">角色详解</Link></li>
              <li><Link className="transition-colors hover:text-accent-300" to="/relationships">人物关系</Link></li>
              <li><Link className="transition-colors hover:text-accent-300" to="/faq">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-widest text-background-50">阅读索引</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link className="transition-colors hover:text-accent-300" to="/characters#protagonist">主角介绍</Link></li>
              <li><Link className="transition-colors hover:text-accent-300" to="/characters#stepmother">继母角色</Link></li>
              <li><Link className="transition-colors hover:text-accent-300" to="/characters#stepsister">继姐角色</Link></li>
              <li><Link className="transition-colors hover:text-accent-300" to="/relationships">关系网图解</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-background-100/15 pt-6 text-xs text-background-200/70 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} 继母与继姐·人物图鉴 · 仅供读者交流与作品科普使用</p>
          <p>以作品为准，本站内容仅供参考与梳理</p>
        </div>
      </div>
    </footer>
  );
}